import React from "react";
import { BsInfoCircle } from "react-icons/bs";
import "./additional-information.css";

const AdditionalInformation = ({
	title = "Informações adicionais",
	description = "",
	items = [],
	className = ""
}) => {
	const hasItems = Array.isArray(items) && items.length > 0;

	if (!description && !hasItems) {
		return null;
	}

	return (
		<section className={`additional-information ${className}`.trim()}>
			<div className="additional-information__header">
				<BsInfoCircle className="additional-information__icon" />

				<h3 className="additional-information__title">
					{title}
				</h3>
			</div>

			{description && (
				<p className="additional-information__description">
					{description}
				</p>
			)}

			{hasItems && (
				<ul className="additional-information__list">
					{items.map((item, index) => (
						<li
							key={`${item}-${index}`}
							className="additional-information__item"
						>
							{item}
						</li>
					))}
				</ul>
			)}
		</section>
	);
};

export default AdditionalInformation;